import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

import { INDICATOR_NAME_CHILDREN } from "~/pages/Indicators/options";
import { getColumnSortOrder } from "~/shared/ui/TableV2/lib/applyColumnSort";

const indicatorsAllowedSortFields = [
  "id",
  "type",
  "nameRu",
  "nameEn",
  "unit",
  "period",
];

export const getIndicatorsSortableApiKeys = (
  lang: string | null | undefined,
) => {
  const nameKey =
    lang === "en" ? INDICATOR_NAME_CHILDREN[1] : INDICATOR_NAME_CHILDREN[0];
  return ["id", "type", "unit", "period", nameKey];
};

export const indicatorsSortFieldForQuery = (field?: string) => {
  if (!field) return undefined;
  if (!indicatorsAllowedSortFields.includes(field)) return undefined;
  return field;
};

export const getIndicatorsColumns = (
  t: TFunction,
  sortField?: string,
  sortType?: string,
  lang?: string | null,
): ColumnsType<any> => {
  const nameSortKey =
    lang === "en" ? INDICATOR_NAME_CHILDREN[1] : INDICATOR_NAME_CHILDREN[0];

  return [
    {
      title: t("indicators.id"),
      dataIndex: "id",
      key: "id",
      sorter: true,
      sortOrder: getColumnSortOrder("id", sortField, sortType),
    },
    {
      title: t("indicators.type"),
      dataIndex: "type",
      key: "type",
      sorter: true,
      sortOrder: getColumnSortOrder("type", sortField, sortType),
    },
    {
      title: t("indicators.name"),
      dataIndex: "name",
      key: nameSortKey,
      sorter: true,
      sortOrder: getColumnSortOrder(nameSortKey, sortField, sortType),
      render: (value: string) =>
        value ? (
          <span style={{ maxWidth: 500, display: "inline-block" }}>
            {value}
          </span>
        ) : (
          ""
        ),
    },
    {
      title: t("indicators.unit"),
      dataIndex: "unit",
      key: "unit",
      sorter: true,
      sortOrder: getColumnSortOrder("unit", sortField, sortType),
      render: (value: string) => (value ? t(`indicators.${value}`) : ""),
    },
    {
      title: t("indicators.period"),
      dataIndex: "period",
      key: "period",
      sorter: true,
      sortOrder: getColumnSortOrder("period", sortField, sortType),
      render: (value: string) => (value ? t(`indicators.${value}`) : ""),
    },
  ];
};
